import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import { initializeMsal, msalInstance } from './authClient';
import { GoogleAuthProvider } from './contexts/GoogleAuthContext';
import 'leaflet/dist/leaflet.css';
import './styles/App.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

initializeMsal()
    .catch((error) => {
        console.error('MSAL initialization failed:', error);
    })
    .finally(() => {
        root.render(
            <React.StrictMode>
                <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
                    <GoogleAuthProvider>
                        <MsalProvider instance={msalInstance}>
                            <App />
                        </MsalProvider>
                    </GoogleAuthProvider>
                </GoogleOAuthProvider>
            </React.StrictMode>
        );
    });